const stepperBlocks = document.querySelectorAll('.stepper__item');

const observerStepper = new IntersectionObserver((entries) => {
  // Sort entries by their vertical position on the screen
  const visibleEntries = entries
    .filter(entry => entry.isIntersecting)
    .sort((a, b) => a.boundingClientRect.top - b.boundingClientRect.top);

  if (visibleEntries.length > 0) {
    // Get the topmost visible element
    const topVisible = visibleEntries[0].target;

    // Remove 'active' from all, then add to the topmost visible one
    stepperBlocks.forEach(block => block.classList.remove('active'));
    topVisible.classList.add('active');
  }
}, {
  threshold: 0.5,
});

stepperBlocks.forEach(block => observerStepper.observe(block));
